import React, { useEffect, useState, useContext } from 'react';
import InfiniteScroll from '../../InfiniteScroll/InfiniteScroll';
import { LeadData } from '../../UploadedBankStatements/ManullyAddBankStaatements/ManuallyAddBankStatement';
import {
  getNetCashFlow,
  getNetCashFlowMetaData
} from '../../../constants/bank-statement-api';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import numberFormat from '../../../constants/NumberFormat';
import { get } from 'lodash';

const headings = [
  {
    name: 'Month',
    key: 'Month'
  },
  {
    name: 'Avg Inflow',
    key: 'Avg Inflow'
  },
  {
    name: 'Avg Outflow',
    key: 'Avg Outflow'
  },
  {
    name: 'Net Cashflow',
    key: 'Net Cashflow'
  },
  {
    name: 'Monthly avg balance',
    key: 'Monthly avg balance'
  },
  {
    name: 'Outflow Count',
    key: 'Outflow Count'
  },
  {
    name: 'Inflow Count',
    key: 'Inflow Count'
  }
];

const NetCashFlow = () => {
  const leadDetails = useContext(LeadData);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [pageMetadata, setPageMetadata] = useState({ total_data: 0 });
  const [metaData, setMetaData] = useState({});

  const netCashflow = async ({ pageNum }) => {
    setLoading(true);
    return getNetCashFlow({
      leadId: leadDetails?.leadId,
      applicantId: leadDetails?.applicantId,
      docId: leadDetails?.docId,
      pageNumber: pageNum,
      pageSize
    })
      .then(res => {
        if (typeof res !== 'object') return;
        setPageMetadata({ total_data: res?.total_data });

        let response = {
          averageInflow: res?.average_inflow,
          averageOutflow: res?.average_outflow,
          netCashFlow: res?.net_cash_flow,
          monthlyAverageBalance: res?.monthly_average_balance,
          outflowCount: res?.outflow_count,
          inflowCount: res?.inflow_count
        };

        return response;
      })
      .catch(() => {
        return {};
      });
  };

  const getMetaData = async () => {
    setLoading(true);
    return getNetCashFlowMetaData({
      leadId: leadDetails?.leadId,
      applicantId: leadDetails?.applicantId,
      docId: leadDetails?.docId
    })
      .then(res => {
        if (typeof res !== 'object') return;
        setMetaData(res);
      })
      .catch(() => {
        return {};
      });
  };

  const getValues = async ({ pageNum }) => {
    let data = await netCashflow({ pageNum });
    await getMetaData();

    addData(data);
  };

  useEffect(() => {
    getValues({ pageNum: pageNumber });
  }, []);

  const addData = ({
    averageInflow,
    averageOutflow,
    netCashFlow,
    monthlyAverageBalance,
    outflowCount,
    inflowCount
  }) => {
    let newData = [];
    Object.values(monthlyAverageBalance || {}).map((result, index) => {
      let month = result?.[1]?.month;
      let year = result?.[1]?.year;
      let currAvgInflow = averageInflow?.find(res => {
        if (res?.[1]?.month === month && res?.[1]?.year === year) return res;
      });
      let currAvgOutflow = averageOutflow?.find(res => {
        if (res?.[1]?.month === month && res?.[1]?.year === year) return res;
      });
      let currNetCash = netCashFlow?.find(res => {
        if (res?.[1]?.month === month && res?.[1]?.year === year) return res;
      });
      let currMonthlyAverage = monthlyAverageBalance?.find(res => {
        if (res?.[1]?.month === month && res?.[1]?.year === year) return res;
      });
      let currOutflowCount = outflowCount?.find(res => {
        if (res?.[1]?.month === month && res?.[1]?.year === year) return res;
      });
      let currInflowCount = inflowCount?.find(res => {
        if (res?.[1]?.month === month && res?.[1]?.year === year) return res;
      });

      newData.push({
        month: month,
        year: year,
        avgInflow: parseInt(get(currAvgInflow, '[1].closing_balance')),
        avgOutflow: parseInt(get(currAvgOutflow, '[1].closing_balance')),
        netCash: parseInt(get(currNetCash, '[1].net_cash_flow')),
        monthlyAvg: parseInt(get(currMonthlyAverage, '[1].closing_balance')),
        outflowCount: parseInt(get(currOutflowCount, '[1].closing_balance')),
        inflowCount: parseInt(get(currInflowCount, '[1].closing_balance'))
      });
    });
    setLoading(false);
    setData([...data, ...newData]);
  };

  const handlePagnation = () => {
    if (pageSize * pageNumber >= pageMetadata.total_data) return;

    if (loading) return;
    getValues({ pageNum: pageNumber + 1 });
    setPageNumber(e => e + 1);
  };

  return (
    <div className="w-full">
      <div className="w-full bg-white  py-4 mt-5 ">
        <InfiniteScroll
          bottomLocation={700}
          handleScrollsuccess={handlePagnation}
          showDefaultLoader={false}
        >
          <div className="w-full max-h-screen overflow-auto px-3">
            <table className="table-auto">
              <thead className="text-grey-600">
                <tr>
                  {headings.map(heading => (
                    <th
                      style={{ border: 'solid lightgray 1px' }}
                      className="px-1 w-80 py-3"
                    >
                      {heading.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((val, index) => (
                  <tr>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      {`${moment(val?.month, 'MM').format('MMM')}, ${
                        val?.year
                      }`}
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {val.avgInflow ? numberFormat(val.avgInflow) : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {val.avgOutflow ? numberFormat(val.avgOutflow) : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {val.netCash ? numberFormat(val.netCash) : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {val.monthlyAvg ? numberFormat(val.monthlyAvg) : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      {val.outflowCount
                        ? numberFormat(val.outflowCount)
                        : '---'}
                    </td>
                    <td
                      style={{
                        border: 'solid lightgray 1px',
                        maxWidth: '100px'
                      }}
                      className="text-center px-1 py-3"
                    >
                      {val.inflowCount ? numberFormat(val.inflowCount) : '---'}
                    </td>
                  </tr>
                ))}
              </tbody>

              {pageNumber === 1 && loading ? null : (
                <tbody className="sticky bottom-0 bg-white">
                  <tr>
                    <th
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      Total
                    </th>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {metaData?.total_average_inflow
                          ? numberFormat(metaData?.total_average_inflow)
                          : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {metaData?.total_average_outflow
                          ? numberFormat(metaData?.total_average_outflow)
                          : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {metaData?.total_net_cash_flow
                          ? numberFormat(metaData?.total_net_cash_flow)
                          : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {metaData?.total_monthly_average_balance
                          ? numberFormat(
                              metaData?.total_monthly_average_balance
                            )
                          : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      {metaData?.total_outflow_count
                        ? numberFormat(metaData?.total_outflow_count)
                        : '---'}
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      {metaData?.total_inflow_count
                        ? numberFormat(metaData?.total_inflow_count)
                        : '---'}
                    </td>
                  </tr>
                  <tr>
                    <th
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      Monthly Avg
                    </th>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {metaData?.mean_average_inflow
                          ? numberFormat(metaData?.mean_average_inflow)
                          : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {metaData?.mean_average_outflow
                          ? numberFormat(metaData?.mean_average_outflow)
                          : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {metaData?.average_net_cash_flow
                          ? numberFormat(metaData?.average_net_cash_flow)
                          : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {metaData?.average_monthly_average_balance
                          ? numberFormat(
                              metaData?.average_monthly_average_balance
                            )
                          : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      {metaData?.average_outflow_count
                        ? numberFormat(metaData?.average_outflow_count)
                        : '---'}
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1 py-3"
                    >
                      {metaData?.average_inflow_count
                        ? numberFormat(metaData?.average_inflow_count)
                        : '---'}
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </InfiniteScroll>

        {loading && (
          <div className="mx-auto table items-center mt-8">
            <CircularProgress />
          </div>
        )}
        {!loading && data.length === pageMetadata?.total_data && (
          <div className="mx-auto table items-center mt-8">
            {data?.length === 0 && 'No data to show!'}
            {data?.length !== 0 && 'No more data to show!'}
          </div>
        )}
      </div>
    </div>
  );
};

export default NetCashFlow;
